import { isMeasurementExcluded, privacySignalEnabled, saveMeasurementPreference, startMeasurement } from './metrics';

startMeasurement();
const status = document.querySelector<HTMLElement>('#measurement-status');
const button = document.querySelector<HTMLButtonElement>('#measurement-toggle');
if (status && button) {
  const excluded = isMeasurementExcluded();
  status.textContent = privacySignalEnabled()
    ? 'Measurement is off because your browser sends a privacy preference.'
    : excluded ? 'This browser is excluded from action counts and page-view analytics.'
      : 'This browser is included in aggregate measurement on relayrescue.app.';
  button.textContent = excluded ? 'Include this browser' : 'Exclude this browser';
  button.disabled = privacySignalEnabled();
  button.addEventListener('click', () => {
    if (saveMeasurementPreference(!excluded)) {
      // This is the privacy page, so reloading cannot discard an open archive.
      history.replaceState(null, '', '/privacy.html#measurement');
      location.reload();
    } else {
      status.textContent = 'Your browser blocked saving this preference. To exclude a test visit, open https://relayrescue.app/?rr_exclude=1 each time. Already-loaded page analytics stops after leaving this page.';
    }
  });
}
